module.exports = __webpack_public_path__ + "static/scblogo-0dd9c1c7d9d0f82af1dba5dee62e730f.png";